import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

/**
 * Prevents authenticated users from accessing public-only routes (e.g. /login).
 * If the user is already logged in, redirect them straight to the app.
 */
export const guestGuard: CanActivateFn = async () => {
  const auth = inject(Auth);
  const router = inject(Router);

  await auth.initialized;

  if (auth.isAuthenticated) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
